module.exports = __webpack_public_path__ + "img/call.c4748ad0.svg";